import { InputSearch } from 'basic-ui-lib';
import { IScreen } from 'modules/dashboard/interfaces/api';
import ScreenItemMobile from 'modules/dashboard/screens/Dashboard/components/ScreenItemMobile';
import styled from 'styled-components';

interface StoreDevicesProps {
  devices: IScreen[];
}

const StoreDevices = ({ devices }: StoreDevicesProps) => {
  return (
    <Container>
      <InputSearch placeholder='Search device name' />
      {devices?.map((device) => (
        <ScreenItemMobile key={device.id} item={device} />
      ))}
    </Container>
  );
};

export default StoreDevices;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
`;
